module.exports = __webpack_public_path__ + "static/media/banana-busd.08c65be4.svg";